import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-electronic-billing-generate-credit-note',
  templateUrl: './electronic-billing-generate-credit-note.component.html',
  styleUrls: ['./electronic-billing-generate-credit-note.component.scss']
})
export class ElectronicBillingGenerateCreditNoteComponent implements OnInit {

  value:any;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  emailAgent = true;
  emailUser = true;

  ngOnInit(): void {
    const dto = {
      id:this.value,
      enviarEmail:this.emailAgent,
      enviarCopia:this.emailUser,
    }
    this.change.emit(dto)
  }

  agentChange($event:any) {
    this.emailAgent = $event;
    const dto = {
      id:this.value,
      enviarEmail:this.emailAgent,
      enviarCopia:this.emailUser,
    }
    this.change.emit(dto)
  }

  userChange($event:any) {
    this.emailUser = $event;
    const dto = {
      id:this.value,
      enviarEmail:this.emailAgent,
      enviarCopia:this.emailUser,
    }
    this.change.emit(dto)
  }
}
